type AddressFormSubmit = () => Promise<boolean>;

let deliverySubmit: AddressFormSubmit | null = null;
let billingSubmit: AddressFormSubmit | null = null;

export const addressFormBridge = {
  registerDelivery: (fn: AddressFormSubmit | null) => {
    deliverySubmit = fn;
  },
  registerBilling: (fn: AddressFormSubmit | null) => {
    billingSubmit = fn;
  },
  submitDelivery: async () => {
    if (!deliverySubmit) return true;
    return deliverySubmit();
  },
  submitBilling: async () => {
    if (!billingSubmit) return true;
    return billingSubmit();
  },
};
